import ResetPassCard from "./ResetPassCard";
import AnimatedImages from "./AnimatedImages";
function ResetPass() {
  return (
    <>
      <AnimatedImages />
      <ResetPassCard />
    </>
  );
}

export default ResetPass;
